/* Version: 3.5.137 */
'use client';
var common = {
  branding: {
    manulifeLogoText: 'Logo Manuvie'
  },
  errors: {
    enterValidDate: 'Veuillez entrer une date valide'
  },
  labels: {
    optional: 'Optionnel'
  }
};
var frCA = {
  common: common,
  carousel: {
    leftArrow: function leftArrow(itemType) {
      return "Afficher le ".concat(itemType, " pr\xE9c\xE9dent");
    },
    rightArrow: function rightArrow(itemType) {
      return "Afficher le ".concat(itemType, " suivant");
    },
    disabled: 'désactivé',
    displayed: function displayed(itemType, direction) {
      return direction === 'suivant' || direction === 'précédent' ? "Le ".concat(itemType, " ").concat(direction, " est maintenant affich\xE9") : "Le ".concat(direction, " ").concat(itemType, " est maintenant affich\xE9");
    },
    next: 'suivant',
    previous: 'précédent',
    first: 'premier',
    last: 'dernier',
    current: 'item courant'
  },
  global: {
    month: {
      january: 'janvier',
      february: 'février',
      march: 'mars',
      april: 'avril',
      may: 'mai',
      june: 'juin',
      july: 'juillet',
      august: 'août',
      september: 'septembre',
      october: 'octobre',
      november: 'novembre',
      december: 'décembre'
    },
    day: {
      sunday: 'dimanche',
      monday: 'lundi',
      tuesday: 'mardi',
      wednesday: 'mercredi',
      thursday: 'jeudi',
      friday: 'vendredi',
      saturday: 'samedi'
    },
    dayAbbr: {
      sunday: 'Di',
      monday: 'Lu',
      tuesday: 'Ma',
      wednesday: 'Me',
      thursday: 'Je',
      friday: 'Ve',
      saturday: 'Sa'
    },
    dateAbbr: {
      day: 'j',
      month: 'm',
      year: 'a'
    }
  },
  dataTable: {
    emptyTableMessage: "La table n'a pas de lignes",
    dropdownFilterDefault: 'Tout',
    textFilterPlaceholder: 'Recherche',
    currentItemAriaLabel: 'Page actuelle',
    navigationAriaLabel: 'Contrôle des pages',
    resetFilters: 'Réinitialiser le tableau',
    filterAriaLabel: function filterAriaLabel(_ref) {
      var columnName = _ref.columnName;
      return "Filtrer les r\xE9sultats par ".concat(columnName);
    },
    paginationResultsSize: function paginationResultsSize(_ref2) {
      var min = _ref2.min,
        max = _ref2.max,
        total = _ref2.total;
      return "Affichage ".concat(min, "-").concat(max, " sur ").concat(total);
    },
    selectedRowsCount: function selectedRowsCount(count) {
      return "".concat(count, " articles s\xE9lectionn\xE9s");
    }
  },
  datePicker: {
    toggleButtonTitle: 'Basculer le sélecteur de date',
    toggleNextMonthTitle: 'Aller au mois prochain',
    togglePreviousMonthTitle: 'Aller au mois précédent',
    dateFormatInvalid: common.errors.enterValidDate,
    dateOutsideRangeTemplate: function dateOutsideRangeTemplate(_ref3) {
      var before = _ref3.before,
        after = _ref3.after;
      if (before && after) {
        return "Veuillez entrer une date entre ".concat(before, " et ").concat(after);
      }
      if (before) {
        return "Veuillez entrer une date apr\xE8s ".concat(before);
      }
      if (after) {
        return "Veuillez entrer une date avant ".concat(after);
      }
      return common.errors.enterValidDate;
    }
  },
  dateOfBirth: {
    legend: 'Date de naissance',
    day: 'Jour',
    month: 'Mois',
    year: 'Année',
    dayPlaceholder: 'jj',
    monthPlaceholder: 'Choisir',
    yearPlaceholder: 'aaaa',
    invalidDate: 'Veuillez entrer une date valide',
    beyondMinTemplate: function beyondMinTemplate(_ref4) {
      var before = _ref4.before;
      return "Veuillez entrer une date apr\xE8s ".concat(before);
    },
    beyondMaxTemplate: function beyondMaxTemplate(_ref5) {
      var after = _ref5.after;
      return "Veuillez entrer une date avant ".concat(after);
    }
  },
  expandableParagraph: {
    showLess: 'Montrer moins',
    showMore: 'Montrer plus'
  },
  fileUpload: {
    errorFileType: "Désolé, ce type de fichier n'a pas fonctionné. Veuillez réessayer.",
    errorFileSize: 'Désolé, ce fichier était trop volumineux. Veuillez réessayer.',
    errorCombinedFileSize: 'Désolé, vos fichiers dépassent la taille de fichier maximale combinée de',
    errorFileDuplicate: 'Désolé, il semble que vous ayez déjà téléchargé ce fichier.',
    inputAriaLabel: 'Entrée de fichier, cliquez pour sélectionner un fichier',
    maxFilesMessage: 'Vous avez téléchargé le nombre maximum de fichiers.',
    instructionsMobile: 'Parcourir vos fichiers',
    instructionsDragDrop: 'Faites-le glisser et déposez-le ici',
    instructionsOr: 'OU',
    instructionsBrowse: 'parcourez vos fichiers',
    smallLabel: 'Parcourez vos fichiers',
    files: 'Des dossiers:',
    fileNameTemplate: function fileNameTemplate(fileName) {
      return "Nom du fichier ".concat(fileName);
    },
    fileSizeTemplate: function fileSizeTemplate(fileSize) {
      return "Taille du fichier ".concat(fileSize);
    },
    view: 'Voir',
    viewAriaTemplate: function viewAriaTemplate(fileName) {
      return "Voir ".concat(fileName);
    },
    delete: 'Supprimer',
    deleteAriaTemplate: function deleteAriaTemplate(fileName) {
      return "Supprimer ".concat(fileName);
    },
    close: 'Fermer',
    unitByte: 'o',
    unitKilobyte: 'ko',
    unitMegabyte: 'Mo'
  },
  footer: {
    logoAltText: common.branding.manulifeLogoText,
    defaultCopyrightText: "La Compagnie d'Assurance-Vie Manufacturers",
    quickLinksHeader: 'Liens rapides',
    externalLinkText: 'Ouvrir dans un nouvel onglet'
  },
  messageCard: {
    closeIconAriaLabelDefault: 'Ignorer le message'
  },
  mobileInput: {
    countryCodeLabel: 'Le code du pays',
    phoneNumberLabel: 'Numéro de téléphone'
  },
  modal: {
    closeButtonAriaLabelDefault: 'Fermer Modal'
  },
  pagination: {
    previousAltText: 'Précédent',
    nextAltText: 'Suivant',
    preposition: 'de'
  },
  plusMinus: {
    ariaLabelPlusDefault: 'Augmenter la valeur',
    ariaLabelMinusDefault: 'Diminuer la valeur'
  },
  progressBar: {
    ariaLabelComplete: 'Terminé',
    ariaLabelCurrent: 'Courant',
    labelTemplate: function labelTemplate(_ref6) {
      var currentStep = _ref6.currentStep,
        totalSteps = _ref6.totalSteps;
      return "\xC9tape ".concat(currentStep, " de ").concat(totalSteps);
    },
    loading: 'Chargement'
  },
  select: {
    placeholder: 'Sélectionner'
  },
  sideNav: {
    menuHeaderLinkAltText: 'Maison Manuvie',
    brandLinkAlt: 'Maison Manuvie',
    currentAriaLabel: 'courant',
    menuItemAriaLabel: 'item de menu',
    subMenuAriaLabel: 'sous-menu',
    subMenuStartsAriaLabel: 'Début du sous-menu - ',
    subMenuEndsAriaLabel: ' - fin du sous-menu',
    secondaryAriaLabel: 'secondaire',
    menuTitleAriaLabel: 'titre de menu',
    primaryAriaLabelDesktop: 'principal',
    primaryAriaLabelMobile: 'mobile',
    currentSectionAriaLabel: 'section courante',
    languageToggleText: 'English',
    hamburgerLogoAlt: common.branding.manulifeLogoText,
    mobileMenuSignInText: 'Ouvrir une session',
    mobileMenuSignOutText: 'Déconnexion',
    mobileContactUsText: 'Nous joindre',
    hamburgerOpenAriaLabel: 'Ouvrir le menu',
    hamburgerCloseAriaLabel: 'Fermer le menu',
    // new SideNav
    brandLogo: common.branding.manulifeLogoText,
    wordmarkLogo: common.branding.manulifeLogoText,
    hamburgerOpen: 'Ouvrir le menu',
    hamburgerOpenLabel: 'Menu',
    hamburgerClose: 'Fermer le menu',
    hamburgerCloseLabel: 'Fermer',
    mobileFooterSection: 'Navigation mobile, liens inférieurs',
    externalLinkText: 'Ouvrir dans un nouvel onglet'
  },
  table: {
    columnSortable: 'la colonne peut être triée',
    sortedAscending: 'tri croissant',
    sortedDescending: 'tri décroissant',
    activateSortAscending: 'activer pour trier la colonne en ordre croissant',
    activateSortDescending: 'activer pour trier la colonne en ordre décroissant',
    emptyTableMessage: "La table n'a pas de lignes"
  },
  textArea: {
    maxLengthAriaLabelTemplate: function maxLengthAriaLabelTemplate(current, max) {
      return "nombre de caract\xE8res ".concat(current, " sur ").concat(max);
    }
  },
  textInput: {
    show: 'AFFICHER',
    showPasswordAriaLabel: 'Afficher le mot de passe',
    hide: 'CACHER',
    hidePasswordAriaLabel: 'Cacher le mot de passe',
    passwordDisplayed: 'Le mot de passe est actuellement affiché',
    passwordHidden: 'Le mot de passe est actuellement caché',
    passwordNowDisplayed: 'Le mot de passe est maintenant affiché',
    passwordNowHidden: 'Le mot de passe est maintenant caché'
  },
  textLink: {
    externalLinkText: 'Ouvrir dans un nouvel onglet'
  },
  tooltip: {
    ariaLabelDefault: 'info-bulle',
    close: "fermer l'info-bulle"
  },
  utilityHeader: {
    currentSectionAriaLabel: 'section courante',
    langToggleAriaLabel: 'English',
    langToggleText: 'en',
    mobileLogoAlt: common.branding.manulifeLogoText,
    skipToMainNavText: 'Passer à la navigation principale',
    skipToMainContentText: 'Passer au contenu principal',
    skipToSubMenuText: 'Passer sous-menu',
    skipToFooterText: 'Passer au pied de page',
    navAriaLabel: 'Globale',
    signOutLabel: 'déconnexion',
    // new utilityHeader
    skipToMainContentLabel: 'Passer au contenu principal',
    skipToMainNavLabel: 'Passer à la navigation principale',
    skipToSubNavLabel: 'Passer à la navigation secondaire',
    skipToFooterLabel: 'Passer au pied de page',
    contactUsLabel: 'Nous joindre',
    langAbbreviation: 'en',
    langLabel: 'English',
    langAriaLabel: 'English',
    logoAriaLabel: common.branding.manulifeLogoText,
    profileLabel: 'Profil',
    searchLabel: 'Recherche',
    signInLabel: 'Ouvrir une session'
  }
};

export { frCA as default };
